import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

// Slider home
  const homeSlideshow =
  document.querySelector(".slideshow .swiper-container") !== null;

    if (homeSlideshow) {
    let nbSlides = document.querySelectorAll(
        ".slideshow .swiper-container .swiper-slide"
    ).length;
    let dataSlideAuto = document
        .querySelector(".slideshow .swiper-container")
        .getAttribute("data-slide_auto");
    let dataSlideSpeed = document
        .querySelector(".slideshow .swiper-container")
        .getAttribute("data-slide_speed");
    dataSlideSpeed = dataSlideSpeed + "000";

    Swiper.use([A11y, Autoplay, EffectFade, Navigation, Pagination]);

    let config = {
        grabCursor: "true",
        speed: 700,
        loop: false,

        effect: "fade",
        fadeEffect: {
        crossFade: true,
        },

        // Pagination (bullet)
        pagination: {
        el: ".c-pagination__bullets",
        type: "bullets", // default
        clickable: true,
        },

        a11y: {
        enabled: true,
        prevSlideMessage: "Diapositive précédente",
        nextSlideMessage: "Diapositive suivante",
        paginationBulletMessage: "Aller à la diapositive {{index}}",
        slideLabelMessage: "{{index}} / {{slidesLength}}", // default
        },
    };

    if (dataSlideAuto === "1") {
        config.autoplay = {
        delay: dataSlideSpeed,
        disableOnInteraction: false,
        };
    }

    if (nbSlides > 1) {
        let swiperHome = new Swiper(".slideshow .swiper-container", config);

        if (dataSlideAuto === "1") {
        let boutonPlayPause = document.getElementById("js-boutonAutoplay");
        let iconPause = boutonPlayPause.querySelector(
            ".nav-swiper-autoplay__icon--pause"
        );
        let iconPlay = boutonPlayPause.querySelector(
            ".nav-swiper-autoplay__icon--play"
        );

        // Initial state adjustment
        if (swiperHome.autoplay.running) {
            iconPause.classList.remove("hidden");
            iconPlay.classList.add("hidden");
        } else {
            iconPause.classList.add("hidden");
            iconPlay.classList.remove("hidden");
        }

        boutonPlayPause.addEventListener("click", function () {
            if (swiperHome.autoplay.running) {
            swiperHome.autoplay.stop();

            boutonPlayPause.classList.remove("nav-swiper-autoplay--play");
            boutonPlayPause.classList.add("nav-swiper-autoplay--pause");
            iconPause.classList.add("hidden");
            iconPlay.classList.remove("hidden");
            } else {
            swiperHome.autoplay.start();

            boutonPlayPause.classList.remove("nav-swiper-autoplay--pause");
            boutonPlayPause.classList.add("nav-swiper-autoplay--play");
            iconPause.classList.remove("hidden");
            iconPlay.classList.add("hidden");
            }
        });
        }
    }
    }


    // Slider incontournables
    const incontournablesSlideshow =
        document.querySelector(".incontournables .swiper-container") !== null;

    if (incontournablesSlideshow) {
        const activities = document.querySelectorAll(".incontournables__map-wrapper svg a");

        let incontournablesSlides = document.querySelectorAll(
            ".incontournables .swiper-container .swiper-slide"
        ).length;

        Swiper.use([Navigation, A11y]);

        let incontournablesConfig = {
            effect: "fade",
            grabCursor: "true",
            speed: 700,
            loop: false,
            on: {
                slideChange: updateActiveLink
            },
            breakpoints: {
                1201: {
                    allowTouchMove: false,
                    spaceBetween: 30,
                    slidesPerView: 1,
                },
                961: {
                    allowTouchMove: false,
                    spaceBetween: 20,
                    slidesPerView: 1,
                },
                641: {
                    allowTouchMove: false,
                    spaceBetween: 20,
                    slidesPerView: 1,
                },
                0: {
                    allowTouchMove: true,
                    spaceBetween: 20,
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: `.incontournables__navigation__button--next`,
                prevEl: `.incontournables__navigation__button--prev`,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Diapositive précédente",
                nextSlideMessage: "Diapositive suivante",
                slideLabelMessage: "{{index}} / {{slidesLength}}",
            },
        };

        let swiperIncontournables = new Swiper(".incontournables .swiper-container", incontournablesConfig);

        // Fonction pour gérer les liens "actifs"
        function updateActiveLink() {
            const activeIndex = swiperIncontournables.realIndex;

            // On retire la classe active de tous les liens
            activities.forEach(link => link.classList.remove('active'));

            // On ajoute la classe active au lien correspondant
            if (activities[activeIndex]) {
                activities[activeIndex].classList.add('active');
            }
        }

        // Liens SVG cliquables pour changer de slide
        activities.forEach((link, index) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                swiperIncontournables.slideTo(index);
            });
        });

        updateActiveLink();
    }

      // Slider news
    const newsSlideshow =
    document.querySelector(".news .swiper-container") !== null;

    if (newsSlideshow) {
        let newsSlides = document.querySelectorAll(
            ".news .swiper-container .swiper-slide"
        ).length;

        Swiper.use([Navigation, A11y]);

        let newsConfig = {
            effect: "slide",
            grabCursor: "true",
            speed: 700,
            loop: false,

            breakpoints: {
            1201: {
                allowTouchMove: false,
                spaceBetween: 30,
                slidesPerView: 2,
            },

            961: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 2,
            },

            641: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 2,
            },

            0: {
                allowTouchMove: true,
                spaceBetween: 20,
                slidesPerView: 1,
            },
            },

            navigation: {
            nextEl: `.news__navigation__button--next`,
            prevEl: `.news__navigation__button--prev`,
            },

            a11y: {
            enabled: true,
            prevSlideMessage: "Diapositive précédente",
            nextSlideMessage: "Diapositive suivante",
            slideLabelMessage: "{{index}} / {{slidesLength}}", // default
            },
        };

    
        let swiperEvents = new Swiper(".news .swiper-container", newsConfig);
        
    }
    
    

          // Slider events
          const eventsSlideshow =
          document.querySelector(".events .swiper-container") !== null;
      
          if (eventsSlideshow) {
          let eventsSlides = document.querySelectorAll(
              ".events .swiper-container .swiper-slide"
          ).length;
      
          Swiper.use([Navigation, A11y]);
      
          let eventsConfig = {
              effect: "slide",
              grabCursor: "true",
              speed: 700,
              loop: false,
      
              breakpoints: {
              1201: {
                  allowTouchMove: false,
                  spaceBetween: 30,
                  slidesPerView: 3,
              },
      
              961: {
                  allowTouchMove: false,
                  spaceBetween: 20,
                  slidesPerView: 3,
              },
      
              641: {
                  allowTouchMove: false,
                  spaceBetween: 20,
                  slidesPerView: 2,
              },
      
              0: {
                  allowTouchMove: true,
                  spaceBetween: 20,
                  slidesPerView: 1,
              },
              },
      
              navigation: {
              nextEl: `.events__navigation__button--next`,
              prevEl: `.events__navigation__button--prev`,
              },
      
              a11y: {
              enabled: true,
              prevSlideMessage: "Diapositive précédente",
              nextSlideMessage: "Diapositive suivante",
              slideLabelMessage: "{{index}} / {{slidesLength}}", // default
              },
          };
      
          if (window.innerWidth > 640) {
              if (eventsSlides > 2) {
              let swiperEvents = new Swiper(
                  ".events .swiper-container",
                  eventsConfig
              );
              }
          } else {
              if (eventsSlides > 1) {
              let swiperEvents = new Swiper(
                  ".events .swiper-container",
                  eventsConfig
              );
              }
          }
          }

}
